import React from 'react';
import NO_AVA from 'styles/img/regular-logo.png'
import {inject, observer} from 'mobx-react';
import Collapsible from 'react-collapsible';
import moment from 'moment'
import {Link, withRouter} from 'react-router-dom';
import classNames from 'classnames';
import StripeForm from '../providers/online_workshop_details/StripeForm';
import HttpClient from 'services/HttpClient';
import NavigationWorkshop from 'components/providers/online_workshop_details/NavigationWorkshop';
import ShortWorkshopDetails from '../providers/online_workshop_details/ShortWorkshopDetails';

const PUBLISH_WORKSHOP = '/api/v1/workshops/confirm';
const STATUS_COMPLETED = 'workshop_completed';
const GENERATE_SERTIFICATE = '/api/v1/pdfs/generate_certificate';
const ADD_MODULES = '/api/v1/workshops/approve_add_modules';

@withRouter
@inject('workshopDetails')
@inject('user')
@inject('alert')
@observer
export default class Basic extends React.Component {

  state = {opened: false };

  triggerOpeningAccordion = () => {
    this.setState({opened: !this.state.opened})
  };


  confirm = e => {
    new HttpClient().put(PUBLISH_WORKSHOP, { workshop_id: this.props.workshopDetails.workshop.id,
      workshop_state: (this.props.workshopDetails.workshop.workshop_state === 'new_workshop' ? 1: 0) }).then(el => {

      this.props.workshopDetails.approveModule( this.props.workshopDetails.workshop.workshop_state === 'new_workshop' ? 'confirmed_workshop' : 'new_workshop');
      this.props.alert.success('Successfully updated')
    })
  };

  addModules = e => {
    new HttpClient().put(ADD_MODULES, {
      add_modules: !this.props.workshopDetails.workshop.add_modules,
      workshop_id: this.props.workshopDetails.workshop.id
    }).then(el => {
      this.props.workshopDetails.setModules(!this.props.workshopDetails.workshop.add_modules);
      this.props.alert.success('Successfully updated')
    })
  };

  getUrl = () => {
    return this.props.workshopDetails.workshop.website.includes('http') ?
      this.props.workshopDetails.workshop.website :
      `http://${this.props.workshopDetails.workshop.website}`
  };

  generateSertificate = () => {
    const url = `${GENERATE_SERTIFICATE}?workshop_id=${this.props.workshopDetails.workshop.id}`;
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "GET",
      headers: headers,
      cache: "no-cache"
    };
    fetch(url, init)
    .then(resp => {
      if(resp.status=='200') {
        resp.blob()
        .then(file => {
          let objUrl = window.URL.createObjectURL(file)
          window.open(objUrl)
        });
      } else {
        alert("Something went wrong. Please check your connection or try again later")
      }
    });
  }

  checkIfSoldOut() {
    const {workshop} = this.props.workshopDetails || {};
    return workshop.limited_purchase && workshop.tickets_count <= workshop.used_tickets_count;
  }

  redirectToLogin = () => {
    localStorage.setItem('@workshop_id', this.props.workshopDetails.workshop.id);
    this.props.history.push('/newuser/signin/');
  };

  renderPurchaseButton = () => {
    const {workshopDetails} = this.props;
    const {workshop} = workshopDetails || {};
    if (workshop.workshop_state === "confirmed_workshop" && (moment(workshop.end_date).add(moment(workshop.end_time).hours(), 'hours').isAfter(moment()))) {
      return (
        <div className="workshop-creator-sidebar-publish"
          style={{ marginTop: 10, marginBottom: 10 }}
          onClick={this.redirectToLogin}
        >

          <span className="btn prime bordered" style={{ padding: 15 }}>PURCHASE</span>
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    const user = this.props.user.getUser();
    let display = 'none';
    let soldOut = this.checkIfSoldOut();
    if (user)
      if (user.role === 'admin' ||
        this.props.workshopDetails.workshop.access_type === 'owner' ||
        this.props.workshopDetails.workshop.access_type === 'purchased' ||
        localStorage.getItem("haveAccess")
      )
        display = 'block';

    return (
      <div className="col-12 col-md-3 push-md-9 purchased">
        <div className={classNames('regular-workshop-sidebar')}>
          <ul className="workshop-info">
            <li className='item'>
              <div className="regular-workshop-logo-holder regular-workshop-holder">
                <div className="regular-workshop-logo">
                  { this.props.workshopDetails.workshop.provider_logo_url ?
                    <img src={this.props.workshopDetails.workshop.provider_logo_url} alt="logo"/> :
                    <img src={NO_AVA} alt="avatar" className="no-ava full-ava-preview " style={{width: '100%'}}/>

                  }
                </div>
                <div className="regular-workshop-logo-info">
                  <p className="regular-workshop-logo-provide">PROVIDED BY</p>
                  <p className="regular-workshop-logo-company-name">
                    {this.props.workshopDetails.workshop.provided_by}
                  </p>
                  <span className="btn regular-workshop-logo-btn bordered"
                  onClick={this.triggerOpeningAccordion}>provider info</span>

                </div>

              </div>
              <Collapsible  handleTriggerClick={this.handler} open={this.state.opened}>
                {this.props.workshopDetails.workshop.provider_bio &&
                <div className="preview-holder">
                  <p className="preview-holder-label">PROVIDER BIO</p>
                  <p className="preview-holder-text">
                    {this.props.workshopDetails.workshop.provider_bio} </p>
                </div>
                }
                <div className="workshop-creator-sidebar-additional ">
                  {this.props.workshopDetails.workshop.host &&
                  <div className="preview-holder">
                    <p className="preview-holder-label">HOST</p>
                    <p className="preview-holder-text">{this.props.workshopDetails.workshop.host}</p>
                  </div>
                  }
                  {this.props.workshopDetails.workshop.contact_name &&
                  <div className="preview-holder">
                    <p className="preview-holder-label">Contact Name </p>
                    <p className="preview-holder-text">{this.props.workshopDetails.workshop.contact_name}</p>
                  </div>
                  }
                  { this.props.workshopDetails.workshop.contact_email &&
                  <div className="preview-holder">
                    <p className="preview-holder-label">Contact Email</p>
                    <a href="#" className="preview-holder-link">{this.props.workshopDetails.workshop.contact_email}</a>
                  </div>
                  }
                  {this.props.workshopDetails.workshop.contact_phone &&
                  <div className="preview-holder">
                    <p className="preview-holder-label">Contact Phone Number</p>
                    <a href={ "tel:" + this.props.workshopDetails.workshop.contact_phone} className="preview-holder-link">{this.props.workshopDetails.workshop.contact_phone}</a>
                  </div>
                  }

                </div>

                <div className="workshop-creator-sidebar-less">
                  <div className="btn bordered empty grey-empty"
                       onClick={() => this.setState({opened: false})}>SHOW LESS</div>
                </div>
              </Collapsible>
            </li>
            <li className='item'>
              <div className="regular-workshop-venue regular-workshop-holder" style={{paddingTop: 5}}>
                <p className="regular-workshop-holder-title" style={{marginBottom: 20}}>
                  <span key='title' style={{color: 'rgb(0, 192, 195)'}}>Venue Name:</span>
                  <span key='name' style={{marginLeft: 3,
                    wordWrap: 'break-word',
                    color: 'rgb(0, 192, 195)',
                    textTransform: 'none'}}>{this.props.workshopDetails.workshop.venue_name}</span>

                </p>
                <p className="regular-workshop-venue-place">
                  <i className="ic-map-empty-ico"/>
                  <span className="regular-address">
                    <span key='address'>{this.props.workshopDetails.workshop.venue_address}</span>
                     <span key='country'>{this.props.workshopDetails.workshop.venue_county}</span>
                  </span>
                </p>
                <span className="regular-workshop-venue-data-holder">
                                <span className="date">{moment(this.props.workshopDetails.workshop.start_date).format('D MMM`YY')}</span>
                                <span className="time" style={{marginLeft: 3}}>
                                  {this.props.workshopDetails.workshop.start_time &&
                                    [moment(this.props.workshopDetails.workshop.start_time).format('HH:mm'), '-']
                                  }

                                  {this.props.workshopDetails.workshop.end_time &&
                                    moment(this.props.workshopDetails.workshop.end_time).format('HH:mm')
                                  } </span>
                            </span>
              </div>
            </li>

            {user && user.role === 'admin' &&
              <li>
                <div className="row" style={{marginTop: 10}}>

                  <div className="col-12">
                    <div className="accordion-content-block">
                      <p className="label"> Allow to add modules</p>
                      <div className="switcher">
                        <input type="checkbox"
                          id="hasModules"
                          value={this.props.workshopDetails.workshop.add_modules || false}
                          onChange={this.addModules}
                          checked={this.props.workshopDetails.workshop.add_modules || false} />
                        <label htmlFor="hasModules" />
                      </div>
                    </div>
                  </div>

                  <div className="col-6" style={{ marginTop: 8 }}>
                    <div className="accordion-content-block">
                      <p className="label">Publish?</p>
                      <div className="switcher">
                        <input type="checkbox"
                               id="publishWorkshop"
                               value={this.props.workshopDetails.workshop.workshop_state || 'text'}
                               onChange={this.confirm}
                               checked={(this.props.workshopDetails.workshop.workshop_state !== 'new_workshop')}/>
                        <label htmlFor="publishWorkshop"/>
                      </div>
                    </div>
                  </div>


                </div>
              </li>
            }

            {!this.props.location.pathname.includes('admin') &&
            (!this.props.workshopDetails.workshop.access_type || (this.props.workshopDetails.workshop.access_type === 'not_purchased')) &&
            (this.props.workshopDetails.workshop.cost < 0.001 ?
              <li className="item">
                {!soldOut ? (
                    <button
                      key={2}
                      className="workshop-creator-sidebar-publish"
                      onClick={
                        user && this.state.startFreeCourse ? this.sendFreeCourse : this.redirectToLogin}
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        border: 'none',
                      }}
                      disabled={this.state.freeButtonDisabled}
                    >
                      <span
                        className="btn prime bordered"
                        style={{
                          backgroundColor: this.state.freeButtonDisabled ? '#8aa3ae' : '#1ea2e8',
                        }}
                      >
                        Access Workshop
                      </span>
                    </button>
                ) :
                  <div
                    style={{
                      paddingBottom: "15px"
                    }}
                  >
                  <span
                    className="btn prime bordered"
                    style={{
                      padding: 15,
                      cursor: "auto",
                      backgroundColor: '#c4c4c4'
                    }}
                    onClick={this.stopClick}
                  >
                    sold out
                  </span>
                </div>
              }
            </li> :
            <li className="item">
              {user ? (!soldOut ? [
                <div className='price-wrap'>
                  <span className="regular-workshop-summary-title">PRICE:</span>
                  <span className="regular-workshop-summary-text">
                    <span className="currency euro custom-icon-eur"></span>
                    {this.props.workshopDetails.workshop.cost}
                  </span>
                </div>,
                <StripeForm />,
              ] : (
                <div
                  style={{
                    paddingBottom: "15px"
                  }}
                >
                  <span
                    className="btn prime bordered"
                    style={{
                      padding: 15,
                      cursor: "auto",
                      backgroundColor: '#c4c4c4'
                    }}
                    onClick={this.stopClick}
                  >
                    sold out
                  </span>
                </div>
              )) : this.renderPurchaseButton()
            }
          </li>
        )
      }
            <li className='item'>
              <div className="regular-workshop-summary regular-workshop-holder list-workshops" style={{ padding: '5px 0 15px'}}>
                <p className="regular-workshop-holder-title" style={{marginBottom: '10px'}}>SUMMARY</p>

                <ul className=" card-info"
                    style={{display: 'grid', marginTop: '0'}}>

                  <li
                    style={{clear: 'both',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap'}}
                  >
                    <p key="wdw" className="card-info-title" style={{marginLeft: "8px"}}>SUITABLE FOR:</p>
                    <ul className="suitableFor details" >
                      {this.props.workshopDetails.workshop.target_audience && this.props.workshopDetails.workshop.target_audience.map( (el,i) =>
                        <li key={i}><span style={{color: '#00c0c3'}}>{el}</span></li>
                      )}
                    </ul>
                  </li>

                  <li>
                    <span className="regular-workshop-summary-title" key="1">modules:</span>
                    <span className="regular-workshop-summary-text" key="2" style={{color: '#00c0c3'}}>
                      {(this.props.workshopDetails.workshop.modules || []).length}
                    </span>
                  </li>

                  <li>
                    <span className="regular-workshop-summary-title" key="2">CPD Hours:</span>
                    <span className="regular-workshop-summary-text" key="1" style={{color: '#00c0c3'}}>
                      {this.props.workshopDetails.workshop.how_many_hours  ?
                        [this.props.workshopDetails.workshop.how_many_hours,' ',this.props.workshopDetails.workshop.cpd_type] :
                        'Check with provider'
                      }

                    </span>
                  </li>

                  <li>
                    <span className="regular-workshop-summary-title" key="1">PRICE:</span>
                    <span className="regular-workshop-summary-text" key="2" style={{color: '#00c0c3'}}>
                      {parseFloat(this.props.workshopDetails.workshop.cost) ?
                        [
                          <span key="3" className="currency euro custom-icon-eur"/>,
                          this.props.workshopDetails.workshop.cost,
                        ] :
                        CLOSE_ICON }
                      </span>
                  </li>
                  <li className='item'>
                    {this.props.workshopDetails.workshop.website &&
                    [<span className="regular-workshop-summary-title" key="1">Website:</span>,

                      <a href={this.getUrl()}
                        target="_blank"
                        key='2'
                        className="preview-holder-link-web"
                        style={{marginLeft: 8, wordWrap: 'break-word'}}>{this.props.workshopDetails.workshop.website}</a>]
                    }
                  </li>
                  {this.props.workshopDetails.workshop && this.props.workshopDetails.workshop.status == STATUS_COMPLETED && this.props.workshopDetails.workshop.workshop_type !== 'group_supervision' &&
                    <li className='item'>
                      <button className='btn bordered cert-download' onClick={() => this.generateSertificate()}>
                        {Cpd_Cert}
                        <span style={{fontSize: '12px'}}>Certificate of Completion</span>
                      </button>
                    </li>
                  }

                  {(this.props.workshopDetails.workshop.modules || []).length !== 0 &&
                    <li className='item'>
                      <div className="workshop-card-module hide-xs hide-s">

                        <p className="workshop-card-module-title">
                          WORKSHOP INCLUDES {(this.props.workshopDetails.workshop.modules || []).length} MODULES:
                  </p>

                        <ul className="workshop-card-module-list">
                          <NavigationWorkshop display={{ display }} />

                          {(this.props.workshopDetails.workshop.modules || []).map((el, i) =>
                            <ShortWorkshopDetails getModuleDescription={this.props.getModuleDescription} number={i + 1} key={i} title={el.title} />
                          )}
                        </ul>
                      </div>
                    </li>
                  }
                </ul>
              </div>
            </li>

          </ul>
          {user && this.props.workshopDetails.workshop.created_by === user.id &&
          <div className="workshop-creator-sidebar-publish">
            <Link to={`/createregular/${this.props.workshopDetails.workshop.id}`}>
              <span className="btn prime bordered">Edit</span>
            </Link>
          </div>
          }
        </div>
      </div>
    )
  }
}
const CLOSE_ICON = (
  <svg  width="10" height="9">
    <path fill="#FF524F" fillRule="evenodd" d="M2.292.759L.947 2.104l2.7 2.7-2.7 2.701L2.292 8.85l2.701-2.701 2.7 2.701 1.346-1.345-2.701-2.701 2.701-2.7L7.693.759l-2.7 2.7-2.701-2.7"/>
  </svg>
);

const Cpd_Cert = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19">
    <path fill="#fff" fill-rule="evenodd" d="M2 0C.89 0 0 .89 0 2v10a2 2 0 0 0 2 2h8v5l3-3 3 3v-5h2a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2m8 2l3 2 3-2v3.5L19 7l-3 1.5V12l-3-2-3 2V8.5L7 7l3-1.5V2M2 2h5v2H2V2m0 4h3v2H2V6m0 4h5v2H2v-2z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/regular_details/Basic.jsx